import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import '@/styles/styles.sass'
Vue.use(Vuetify);

export default new Vuetify({
    theme: {
      options: {
        customProperties: true
      },
      themes: {
        light: {
          primary: '#363F7A',
          secondary: '#b0bec5',
          accent: '#8c9eff',
          error: '#b71c1c',
          text: '#1D243E',
          white: '#ffffff',
          background: '#E5E5E5'
        },
      },
      },
});
